<section *ngIf="tab" class="margin-standard">
	<!-- AVOID USING METHOD CALLS, PLS REVIEW AND REMOVE THIS COMMENT/REFACTOR -->
	<dl-display-table
		[data]="tab"
		[bordered]="true"
		[attr.data-cy]="tab?.config?.id + '-table'"
		[padded]="true"
		[striped]="true"
		[headersXFormatter]="benchmarkTemplateFormatter()"
		[tooltipFormatter]="benchmarkTemplateFormatter()"
	></dl-display-table>
</section>
<ac-tpm-disclosure></ac-tpm-disclosure>
<section *ngIf="asOfDateSNP" class="disclaimer-container margin-standard">
	<span dcrHTMLKey="BETA_SNP500_AS_OF">The data for Beta to S&P 500 is as of</span> {{ asOfDateSNP }}
</section>
